"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const react_1 = __importStar(require("react"));
const Passenger_1 = __importDefault(require("./Passenger"));
const dayjs_1 = __importDefault(require("dayjs"));
const axios_1 = __importDefault(require("axios"));
function calendar(props) {
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(null);
    const [calendarData, setCalendarData] = (0, react_1.useState)(null);
    const handleDateChange = (year, month, day) => {
        const date = `${year}-${month}-${day}`;
        console.log(date);
        setSelectedDate(date);
    };
    const getUnavailableDates = () => {
        const baseUrl = "/api/widget/unavailableDates/" + props.uuid;
        axios_1.default
            .get(baseUrl)
            .then((response) => {
            setCalendarData(response.data);
        })
            .catch((error) => {
            console.log(error);
        });
    };
    const disableUnavailableDates = (date) => {
        if (calendarData) {
            const dateString = (0, dayjs_1.default)(date).format("YYYY-MM-DD");
            return calendarData.unavailableDates.includes(dateString);
        }
        return false;
    };
    (0, react_1.useEffect)(() => {
        getUnavailableDates();
    }, [props]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !calendarData && react_1.default.createElement(material_1.Typography, null, "Loading Available Dates..."),
        calendarData && (react_1.default.createElement("div", { id: "calendar" },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Event Dates")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(x_date_pickers_1.DateCalendar, { onChange: (e) => {
                        handleDateChange(e.$y, e.$M + 1, e.$D);
                    }, minDate: (0, dayjs_1.default)(), shouldDisableDate: disableUnavailableDates })),
            selectedDate && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Passenger_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: selectedDate, parentElementId: "calendar" })))))));
}
exports.default = calendar;
